module.exports = new __parcel__URL__("righteousshield.6c67e5db.png").toString();